// extracted by mini-css-extract-plugin
export default {"main":"_6527c1ec6a _0c8e0cd358","xmark":"eea03ea9e5","fl_img":"e4dcfcc27f _54d102e1c3"};